export default "__VITE_ASSET__CMw2_YhI__"